var map = {
	"./404.png": "4a50",
	"./500.png": "c7db",
	"./forgot-password.png": "95e0",
	"./lock-screen.png": "6ab9",
	"./login.png": "1f8b",
	"./maintenance-2.png": "d925e",
	"./maintenance.png": "8b6c",
	"./not-authorized.png": "dd28",
	"./register.jpg": "1880",
	"./reset-password.png": "e0fb",
	"./rocket.png": "e0f8",
	"./vuesax-login-bg.jpg": "f56c",
	"./vuesax-login-bg1.jpg": "73a4",
	"./vuesax-login-bg2.jpg": "9875",
	"./vuesax-login-bg3.jpg": "93fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "da26";